/** Ініціали для плитки робочого простору чи аватара: перші символи двох перших слів, великими (як ini() прототипу v4). */
export function initials(name: string | null | undefined): string {
  return (name || '?').trim().split(/\s+/).map((w) => w[0] ?? '').slice(0, 2).join('').toUpperCase();
}
